import Profile from "@/features/auth/Profile";
import Notifications from "@/features/notifications/Index";
import NotHavePermissions from "@/features/NotHavePermissions";
import CanShow from "./CanShow";

export const commonRoutes = [
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/not-have-permissions",
    element: <NotHavePermissions />,
  },
  {
    path: "/notifications",
    element: <CanShow page={<Notifications />} ifHas={["showNotifications"]} />,
  },
];
